// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ui-font-body: 'Aptos', 'Avenir Next', 'Segoe UI', 'Noto Sans', sans-serif;
  --ui-font-display: 'Iowan Old Style', 'Palatino Linotype', 'Book Antiqua', serif;

  --ui-space-1: 0.25rem;
  --ui-space-2: 0.5rem;
  --ui-space-3: 0.75rem;
  --ui-space-4: 1rem;
  --ui-space-5: 1.25rem;
  --ui-space-6: 1.5rem;
  --ui-space-7: 2rem;

  --ui-shell-max-width: 1860px;
  --ui-shell-gutter: clamp(0.35rem, 1.4vw, 1.4rem);

  --ui-radius-sm: 0.7rem;
  --ui-radius-md: 1rem;
  --ui-radius-lg: 1.25rem;
  --ui-radius-xl: 1.5rem;
  --ui-radius-pill: 999px;

  --ui-elevation-1: 0 10px 24px rgba(13, 36, 52, 0.09);
  --ui-elevation-2: 0 18px 36px rgba(13, 36, 52, 0.12);

  --ui-canvas: #edf3f6;
  --ui-canvas-soft: #f4f8fb;
  --ui-surface: #ffffff;
  --ui-surface-soft: #f7fbfe;
  --ui-border: rgba(42, 78, 102, 0.18);
  --ui-border-strong: rgba(42, 78, 102, 0.28);
  --ui-text: #1a3042;
  --ui-text-soft: #5a7082;
  --ui-accent: #1d5a7c;
  --ui-accent-strong: #15445f;
  --ui-success: #14724f;
  --ui-warning: #956d15;
  --ui-danger: #9c3c32;

  --motion-fast: 150ms;
  --motion-base: 280ms;
  --motion-slow: 420ms;
  --easing-standard: cubic-bezier(0.2, 0.7, 0.2, 1);
  --easing-emphasis: cubic-bezier(0.16, 0.92, 0.24, 1);
}
`, "",{"version":3,"sources":["webpack://./src/styles/tokens.css"],"names":[],"mappings":"AAAA;EACE,2EAA2E;EAC3E,gFAAgF;;EAEhF,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;;EAElB,4BAA4B;EAC5B,gDAAgD;;EAEhD,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;;EAEvB,oDAAoD;EACpD,oDAAoD;;EAEpD,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,oCAAoC;EACpC,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;;EAEpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,iDAAiD;EACjD,oDAAoD;AACtD","sourcesContent":[":root {\n  --ui-font-body: 'Aptos', 'Avenir Next', 'Segoe UI', 'Noto Sans', sans-serif;\n  --ui-font-display: 'Iowan Old Style', 'Palatino Linotype', 'Book Antiqua', serif;\n\n  --ui-space-1: 0.25rem;\n  --ui-space-2: 0.5rem;\n  --ui-space-3: 0.75rem;\n  --ui-space-4: 1rem;\n  --ui-space-5: 1.25rem;\n  --ui-space-6: 1.5rem;\n  --ui-space-7: 2rem;\n\n  --ui-shell-max-width: 1860px;\n  --ui-shell-gutter: clamp(0.35rem, 1.4vw, 1.4rem);\n\n  --ui-radius-sm: 0.7rem;\n  --ui-radius-md: 1rem;\n  --ui-radius-lg: 1.25rem;\n  --ui-radius-xl: 1.5rem;\n  --ui-radius-pill: 999px;\n\n  --ui-elevation-1: 0 10px 24px rgba(13, 36, 52, 0.09);\n  --ui-elevation-2: 0 18px 36px rgba(13, 36, 52, 0.12);\n\n  --ui-canvas: #edf3f6;\n  --ui-canvas-soft: #f4f8fb;\n  --ui-surface: #ffffff;\n  --ui-surface-soft: #f7fbfe;\n  --ui-border: rgba(42, 78, 102, 0.18);\n  --ui-border-strong: rgba(42, 78, 102, 0.28);\n  --ui-text: #1a3042;\n  --ui-text-soft: #5a7082;\n  --ui-accent: #1d5a7c;\n  --ui-accent-strong: #15445f;\n  --ui-success: #14724f;\n  --ui-warning: #956d15;\n  --ui-danger: #9c3c32;\n\n  --motion-fast: 150ms;\n  --motion-base: 280ms;\n  --motion-slow: 420ms;\n  --easing-standard: cubic-bezier(0.2, 0.7, 0.2, 1);\n  --easing-emphasis: cubic-bezier(0.16, 0.92, 0.24, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
